export enum PopperPlacement {
  Top = "top",
  TopStart = "top-start",
  TopEnd = "top-end",
  Bottom = "bottom",
  BottomStart = "bottom-start",
  BottomEnd = "bottom-end",
  Left = "left",
  LeftStart = "left-start",
  LeftEnd = "left-end",
  Right = "right",
  RightStart = "right-start",
  RightEnd = "right-end",
  Auto = "auto",
  AutoEnd = "auto-end",
  AutoStart = "auto-start",
}
